
















































































































import BaseFormEdit from '../../models/base.form.edit';
import Swal from 'sweetalert2';
import { Component } from 'vue-property-decorator';

@Component({})
export default class Edit extends BaseFormEdit {
  form = {
    name: '',
    description: '',
    department: '',
    group: '',
    groups: [],
    departments: [],
    functions: [],
  } as any;

  get title() {
    if(this.form.isNew == null) {
      return '';
    }    

    return this.form.isNew ? this.$t('Добавление роли') as string : `${this.form.name} (${this.getGroupName})`;
  }

  get isFunctionsVisible() {
    return this.form.group !== '';
  }

  get functions() {
    this.form.functions
      .filter((t: any) => t.group != this.form.group)
      .forEach((t: any) => (t.isChecked = false));
    let funcList = this.form.functions.filter((t: any) => t.group == this.form.group);
    if (this.form.department) {
      funcList = funcList.filter((t: any) => (t.department || '').includes(this.form.department));
    }
    return funcList;
  }

  get getGroupName() {
    let group = this.form.group != null && this.form.groups.length > 0
      ? this.form.groups.find((g: any) => g.key == this.form.group).value
      : null;
    if (this.form.department != null && this.form.departments.length > 0) {
      let dep = this.form.departments.find((g: any) => g.key == this.form.department).value;
      if (dep) {
        group = group + `, отдел ${dep}`;
      }
    }
    return group;
  }

  get isAllChecked() {
    let result = true;

    if (this.functions) {
      this.functions.forEach((r: any) => (result = result && r.isChecked));
    }

    return result;
  }

  set isAllChecked(value) {
    if (value) {
      this.functions.forEach((r: any) => (r.isChecked = true));
    } else {
      if (this.isAllChecked) {
        this.functions.forEach((r: any) => (r.isChecked = false));
      }
    }
  }

  onGroupChanged(group) {
    if (group != 1) {
      this.form.department = null;
    }
  }

  validateBeforeSubmit(isGoBack = false) {
    if(this.form.group === '' || this.form.group === null)
    {
      Swal(this.$t('Предупреждение') as string, this.$t('Выберите тип огранизации!') as string, 'warning');
    }
    else {
      if (this.isFunctionValid()) {
        this.submit('/roles', isGoBack);
      } else {
        Swal(this.$t('Предупреждение') as string, this.$t('Выберите хотя бы одну функцию!') as string, 'warning');
      }
    }    
  }

  isFunctionValid() {
    return this.form.functions.filter((t: any) => t.isChecked == true).length > 0;
  }
}
